import { Record } from 'immutable';

import { PicEntity } from '../domain/pic.entity';

export const PicsSliceKey = 'pics';

interface IPicsSliceState {
	all: Array<PicEntity>;
}

const defaults: IPicsSliceState = {
	all: new Array<PicEntity>(),
};

export class PicsSliceState extends Record<IPicsSliceState>(defaults) {
	public static readonly key = PicsSliceKey;

	public setPics(available: Array<PicEntity>): PicsSliceState {
		return this.set('all', available);
	}
}
